<template>
    <div>
        <a class="btn-annotation btn-play-multipage-karaoke"
           href="#"
           :style="data.styleRect"
           @click.prevent="playMultiPageKaraoke"
        >
            <img :src="`${bookInfoState.publicPath}/${props.annot.iconSrc}`"
                 v-if="props.annot.iconSrc"
            >
        </a>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
    import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";
    import cssvar from '@/scss/_variables.scss';

    const colorRect = cssvar.colorRect;
    const {getResizedAnnotationPos, styleAnnotationBtn} = useAnnotationHelper();

    export default {

        props: {
          annot:Object,
          playPageKaraokeBtnData:Object,
          sharedMeta:Object,
          pagenum:Number,
          annotTypes:Array
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState} = useBookInfo();
            const { pageResizeState} = usePageResize();
            const { karaokeState, setCurrentAudioSrc, stopAnimation, playParagraph} = useKaraokeControl();
            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        ...styleAnnotationBtn
                    }
                }),
                wordAudioData:computed(()=>{
                    return  props.sharedMeta['karaoke'][karaokeState.activeGrouptag]["wordAudioData"][bookInfoState.activeSpeech];
                })
            });

            const playMultiPageKaraoke = ()=> {

                stopAnimation();
                usePlayBlockControl().reset();

                //if there is playPageKaraoke button on the current page (note that it doesn't always exist)
                if (props.playPageKaraokeBtnData) {

                    karaokeState.multiWholePageStatus = {
                        btnIdPageMapping: props.annot.btnIdPageMapping, //store a reference of btnIdPageMapping so that the karaoke control knows when to finish.
                        multiPageTargetBtnId:props.playPageKaraokeBtnData.id, //which button id of the target page to point to. It must be the first item in the mapping to start with
                        multiPageTargetPageNum:props.pagenum, //target page number (zero-based).  It must be the first item in the mapping to start with
                        isTargetPlayPageBtn:true,
                        playedPageCount:0
                    };
                } else {

                    karaokeState.multiWholePageStatus = {
                        btnIdPageMapping: props.annot.btnIdPageMapping, //store a reference of btnIdPageMapping so that the karaoke control knows when to finish.
                        multiPageTargetBtnId: props.annot.btnIdPageMapping[0]["aimPageBtnId"], //which button id of the target page to point to. It must be the first item in the mapping to start with
                        multiPageTargetPageNum: props.annot.btnIdPageMapping[0]["aimPageIndex"], //target page number (zero-based).  It must be the first item in the mapping to start with
                        currentPageParaCount: props.annot.btnIdPageMapping.filter(el => el.aimPageIndex === props.annot.btnIdPageMapping[0]["aimPageIndex"]).length,
                        playedParaCount: 0
                    };
                }

                console.log( karaokeState.multiWholePageStatus);

            };


            onMounted(() => {
                console.log("playPageKaraokeBtnData:");
                console.log(props.playPageKaraokeBtnData)

            });

            return {
                props,
                data,
                pageResizeState,
                bookInfoState,
                parserState,
                karaokeState,
                playMultiPageKaraoke,
                playParagraph,
                stopAnimation,
                setCurrentAudioSrc,
                getResizedAnnotationPos
            }

        }
    }

 </script>


<style scoped lang="scss">

    .btn-annotation {

    }
</style>